<template>
  <b-row>
    <b-col
      cols="12"
      class="d-flex justify-content-end"
    >
      <b-button @click="ShowAuditAndTriTab = !ShowAuditAndTriTab">
        {{ actionType }}
      </b-button>

      <b-modal
        v-model="ShowAuditAndTriTab"
        footer-class="d-none"
        body-bg-variant="dark"
        :title="`${actionType}`"
        size="lg"
      >
        <div
          v-if="actionType === 'Add Audit'"
          class="d-flex flex-wrap justify-content-between"
        >
          <div
            v-for="(item, index) in availableAuditsItems"
            :key="index"
            class="p-1 w-50"
          >
            <span @click="handleAlertClick(item.id, 'audit')">
              <b-alert
                show
                class="p-1"
                style="word-break: break-word;"
                variant="light"
              >
                <b-form-checkbox-group
                  v-model="selectedAuditsItems"
                  :aria-describedby="'audit-checkbox-description'"
                >
                  <p><strong>Request Code :</strong> {{ item.request.request_code }}</p>
                  <p><strong>Product Name :</strong> {{ item.product_name }}</p>
                  <p><strong>Location :</strong>{{ item.location }}</p>
                  <p><strong>Company Name :</strong>{{ item.company_name }}</p>
                  <p><strong>Audit Date :</strong>{{ item.audit_date }}</p>
                  <p><strong>Engineer Job :</strong>{{ item.engineer_job }}</p>
                  <b-form-checkbox :value="item.id" />
                </b-form-checkbox-group>
              </b-alert>
            </span>
          </div>
        </div>

        <div
          v-if="actionType === 'Add Training'"
          class="d-flex flex-wrap justify-content-between"
        >
          <div
            v-for="(item, index) in availableTrainingsItems"
            :key="index"
            class="p-1 w-50"
          >
            <span @click="handleAlertClick(item.id, 'training')">
              <b-alert
                show
                class="p-1"
                style="word-break: break-word;"
                variant="light"
              >
                <b-form-checkbox-group
                  v-model="selectedTrainingsItems"
                  :aria-describedby="'training-checkbox-description'"
                >
                  <p><strong>From :</strong> {{ item.training_session.from }}</p>
                  <p><strong>To :</strong>{{ item.training_session.to }}</p>
                  <p><strong>Training Name :</strong>{{ item.training.name }}</p>
                  <p><strong>Trainer :</strong>{{ item.trainer }}</p>
                  <p><strong>Is Attended :</strong>{{ item.is_attended ? 'Yes' : 'No' }}</p>
                  <b-form-checkbox :value="item.id" />
                </b-form-checkbox-group>
              </b-alert>
            </span>

          </div>
        </div>
        <b-button
          v-if="!loader"
          variant="primary"
          @click="EditAuditsAndTrainings"
        >
          Add
        </b-button>
        <b-button
          v-if="loader"
          variant="primary"
          disabled
          class="mr-1"
        >
          <b-spinner
            small
            type="grow"
          />
          Loading...
        </b-button>
      </b-modal>

    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    actionType: {
      type: String,
      required: true,
    },
    openEvaluationId: {
      type: [Number, String],
      required: true,
    },
    /** Rows already linked to this evaluation (from User Trainings / User Audits tables). */
    existingItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ShowAuditAndTriTab: false,
      loader: false,
      loadtable: false,
      errors: {},
      availableAuditsItems: [],
      availableTrainingsItems: [],
      selectedAuditsItems: [],
      selectedTrainingsItems: [],
    }
  },
  watch: {
    openEvaluationId: {
      immediate: true, // optional: call immediately when component mounts if there's a value
      handler(newVal) {
        if (newVal) {
          this.getAvailableItems()
        }
      },
    },
    existingItems: {
      deep: true,
      handler() {
        if (!this.ShowAuditAndTriTab) {
          this.applyPreselectedFromTable()
        }
      },
    },
    ShowAuditAndTriTab(isOpen) {
      if (isOpen) {
        this.applyPreselectedFromTable()
      }
    },
  },
  mounted() {
    this.getAvailableItems()
  },
  methods: {
    existingItemIdSet() {
      return new Set(
        (this.existingItems || [])
          .map(row => row && row.id)
          .filter(id => id != null && id !== ''),
      )
    },
    applyPreselectedFromTable() {
      const existing = this.existingItemIdSet()
      if (this.actionType === 'Add Training') {
        this.selectedTrainingsItems = this.availableTrainingsItems
          .filter(item => existing.has(item.id))
          .map(item => item.id)
      } else if (this.actionType === 'Add Audit') {
        this.selectedAuditsItems = this.availableAuditsItems
          .filter(item => existing.has(item.id))
          .map(item => item.id)
      }
    },
    handleAlertClick(item, type) {
      const targetList = type === 'audit' ? this.selectedAuditsItems : this.selectedTrainingsItems
      const index = targetList.indexOf(item)
      if (index === -1) {
        targetList.push(item)
      } else {
        targetList.splice(index, 1)
      }
    },
    getAvailableItems() {
      this.loadtable = true
      axios.get(`personnel-evaluation/${this.openEvaluationId}/available-items`).then(res => {
        this.availableAuditsItems = decryptData(res.data.payload).data.audits
        this.availableTrainingsItems = decryptData(res.data.payload).data.trainings
        this.applyPreselectedFromTable()
      }).catch(error => {
        if (error.response && error.response.status) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'error',
            },
          })
        }
      })
        .finally(() => {
          this.loadtable = false
        })
    },

    EditAuditsAndTrainings() {
      const isAudit = this.actionType === 'Add Audit'
      const selected = isAudit ? this.selectedAuditsItems : this.selectedTrainingsItems

      this.loader = true
      const payloadTO = isAudit
        ? { audit_ids: selected }
        : { training_ids: selected }

      axios.post(`personnel-evaluation/${this.openEvaluationId}/items`, payloadTO).then(res => {
        if (res.status === 200 || res.status === 201) {
          this.ShowAuditAndTriTab = false
          this.$emit('items-added')
          this.$toasted.show(
            selected.length ? 'Saved successfully' : 'Cleared successfully',
            {
              position: 'top-center',
              duration: 3000,
            },
          )
        }
      }).catch(error => {
        if (error.response && error.response.status) {
          const payload = decryptData(error.response.data.payload).message
          const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
          const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorMessage,
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        }
      }).finally(() => {
        this.loader = false
      })
    },
  },
}
</script>
